import { MemberBulkButtonComponents } from "@components/common/faro-table/faro-table-types";
import { BaseMembersProps, MembersSortBy } from "@custom-types/member-types";
import { SdbProject } from "@custom-types/project-types";
import { InviteMemberToProject } from "@pages/project-details/project-team/invite-member-to-project";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { useProjectTeamMenuOptionsMobile } from "@pages/project-details/project-team/use-project-team-menu-options-mobile";
import { MemberMobileList } from "@components/common/mobile/member-mobile-list";

interface Props extends BaseMembersProps {
  /** List of all the bulk actions and callbacks */
  bulkActionButtons: MemberBulkButtonComponents;

  /** Whether the data for showing a table is loading or not */
  isLoading: boolean;

  /** The selected project if there is one */
  selectedProject?: SdbProject | null;

  /** Current sort by value from the sort dropdown */
  sortBy: MembersSortBy;
}

/**
 * Mobile-specific view for members list.
 * Renders a virtualized list of members for the groups with selection, menu options, and bulk actions.
 */
export function ProjectTeamMobileView({
  members,
  bulkActionButtons,
  isLoading,
  selectedProject,
  sortBy,
}: Props): JSX.Element {
  const menuItems = useProjectTeamMenuOptionsMobile({ selectedProject });

  const { canInviteUsersToPrivateProject } =
    useHasUserValidPermissionProjectLevel({
      project: selectedProject,
    });

  return (
    <MemberMobileList
      members={members}
      isLoading={isLoading}
      bulkActionButtons={bulkActionButtons}
      tableSubject="project"
      menuItems={menuItems}
      renderFooterExtra={() =>
        selectedProject && (
          <InviteMemberToProject
            project={selectedProject}
            buttonVariant="filled"
          />
        )
      }
      shouldShowFooterExtra={canInviteUsersToPrivateProject}
      selectedProject={selectedProject}
      sortBy={sortBy}
    />
  );
}
